import React, { createContext, useContext, useReducer, useEffect } from 'react';

const ReviewContext = createContext();

const initialState = {
  reviews: [],
  currentRating: 0,
  loading: false,
  error: null
};

const reviewReducer = (state, action) => {
  switch (action.type) {
    case 'SET_REVIEWS':
      return { ...state, reviews: action.payload };
    case 'ADD_REVIEW':
      return { ...state, reviews: [action.payload, ...state.reviews] };
    case 'SET_RATING':
      return { ...state, currentRating: action.payload };
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_ERROR':
      return { ...state, error: action.payload };
    default:
      return state;
  }
};

export const ReviewProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reviewReducer, initialState);

  // Load reviews from localStorage on mount
  useEffect(() => {
    const savedReviews = localStorage.getItem('reviews');
    if (savedReviews) {
      try {
        const reviews = JSON.parse(savedReviews);
        dispatch({ type: 'SET_REVIEWS', payload: reviews });
      } catch (error) {
        console.error('Error loading reviews:', error);
      }
    }
  }, []);

  // Save reviews to localStorage when they change
  useEffect(() => {
    localStorage.setItem('reviews', JSON.stringify(state.reviews));
  }, [state.reviews]);

  const addReview = (review) => {
    const newReview = {
      ...review,
      id: Date.now(),
      date: new Date().toISOString()
    };
    dispatch({ type: 'ADD_REVIEW', payload: newReview });
  };

  const setRating = (rating) => {
    dispatch({ type: 'SET_RATING', payload: rating });
  };

  const value = {
    ...state,
    addReview,
    setRating
  };

  return (
    <ReviewContext.Provider value={value}>
      {children}
    </ReviewContext.Provider>
  );
};

export const useReview = () => {
  const context = useContext(ReviewContext);
  if (!context) {
    throw new Error('useReview must be used within a ReviewProvider');
  }
  return context;
};
